import React from 'react';
import { History } from 'lucide-react';
import Timeline from '../../../forum/components/timeline/Timeline';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/Card';

export default function TransactionHistory({ transaction }) {
  if (!transaction.history || transaction.history.length === 0) {
    return (
      <Card className="shadow-hp-sm">
        <CardContent className="p-8 text-center text-subtle">
          Aucun historique disponible pour cette opération.
        </CardContent>
      </Card>
    );
  }

  const events = transaction.history.map(h => ({
    id: h.id,
    content: `Statut modifié à`,
    target: h.newStatus,
    datetime: h.changedAt,
    iconBg: 'bg-[var(--hp-info-500)]'
  }));

  return (
    <Card className="shadow-hp-sm">
      <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] px-6 py-5">
        <History className="h-5 w-5 text-primary" />
        <CardTitle className="text-lg font-medium text-primary">
          Historique des statuts
        </CardTitle>
      </CardHeader>
      
      <CardContent className="p-6">
        <Timeline events={events} />
      </CardContent>
    </Card>
  );
}
